import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('emailFormats');

import { queryEditActive } from './service';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'emailFormats',

  state: {
    newEmail: false,
    selectedItem: null,
    list: [],
    pagination: meta,
    select: 'id,isActive,type,name,fromName',
    notSelectSearch: 'type,process,action',
    expand: {
      process: { select: 'name' },
      action: { select: 'name' },
    },
    paramsEdit: {
      select: 'id,isActive,type,name,updated,created,fromName,subject,content',
      expand: {
        process: { select: 'name' },
        action: { select: 'name' },
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsView: {
      select: 'id,isActive,type,name,updated,created,fromName,subject,content',
      expand: {
        process: { select: 'name' },
        action: { select: 'name' },
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    view: false,
    orderBy: '',
    success: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'emailTemplate/paged',
          params: payload,
        });
        yield put({
          type: 'queryEmails',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewEmail({ payload }, { put }) {
      yield put({
        type: 'addEmail',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewEmail',
          payload,
        });
      }
    },
    *editItemEmail({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'emailTemplate',
          id: payload.id,
          params: payload.params,
        });
        const decoded = atob(table.content);
        table.content = decoded;
        yield put({
          type: 'editEmail',
          payload: {
            ...payload,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *saveNewEmail({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'emailTemplate',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveEmail',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          // TODO: avoid direct pos access
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors || [],
          });
        }
      }
    },
    *saveEditEmail({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'emailTemplate',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveEmail',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error.message) {
          // TODO: avoid direct pos access
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ payload }, { call, put }) {
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
      try {
        const response = yield call(api.apiRoute, {
          route: `emailTemplate/${payload.id}`,
          method: 'delete',
        });
        yield put({
          type: 'deleteEmail',
          payload: response,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${payload.view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: payload.view,
            },
          });
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
        }
      }
    },
    *editActive({ payload }, { call, put }) {
      try {
        yield call(queryEditActive, payload);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *showItemEmail({ view }, { put }) {
      yield put({
        type: 'showEditItemEmail',
        view,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *viewEmail({ payload }, { put }) {
      yield put({
        type: 'queryViewEmail',
        payload,
      });
    },
  },
  reducers: {
    queryEmails(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addEmail(state, { payload }) {
      return {
        ...state,
        newEmail: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        success: false,
      };
    },
    editEmail(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        success: false,
      };
    },
    editOrViewEmail(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    saveEmail(state, { payload }) {
      return {
        ...state,
        saveEmail: payload,
        newEmail: false,
        selectedItem: null,
        id: null,
        success: true,
      };
    },
    deleteEmail(state) {
      return {
        ...state,
      };
    },
    editActives(state, { payload }) {
      const list = state.list.map((item) =>
        item.id === payload.id
          ? {
              ...item,
              isActive: payload.state,
            }
          : item,
      );

      return {
        ...state,
        list,
      };
    },
    showEditItemEmail(state, { view }) {
      return {
        ...state,
        view,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newEmail: false,
        selectedItem: null,
        list: [],
        orderBy: '',
      };
    },
    queryViewEmail(state, { payload }) {
      return {
        ...state,
        selectedItem: {},
        id: payload.id,
      };
    },
  },
};

export default Model;
